module.exports = __webpack_public_path__ + "img/magnifier-icon.d614243b.svg";